export default "__VITE_ASSET__CtIDREkw__"